import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionCollector } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { NavigationUiUtilsService } from '../../navigation-ui-utils.service';

@Component({
    selector: 'da-mobile-navigation',
    templateUrl: './mobile-navigation.component.html',
    styleUrls: ['./mobile-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MobileNavigationComponent implements OnInit, OnDestroy {
    public MAX_BUSINESSFIELD_COLUMNS = 3;
    public MAX_LINKS_PER_COLUMN = 10;
    public MAX_MAIN_ITEMS = 2;
    public MAX_BUSINESSFIELD_ITEMS = 3;
    @Input() translations: object;
    @SubscriptionCollector() private _subscriptions;

    private _$model: BehaviorSubject<any> = new BehaviorSubject({});
    private _$navigationData: BehaviorSubject<any[]> = new BehaviorSubject(null);
    private selectedBusinessField: string;

    constructor(private _navigationUiUtilsService: NavigationUiUtilsService) {}

    @Input()
    set navigationData(value: any[]) {
        this._$navigationData.next(value);
    }

    public get navigationData$(): Observable<any[]> {
        return this._$navigationData.asObservable();
    }

    public get model$(): any {
        return this._$model.asObservable();
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach((data) => {
            if (data) {
                data.unsubscribe();
            }
        });
    }

    ngOnInit(): void {
        this._$model.next({});
        this._setInitialNavValues();
    }

    public getCssClassByBusinessField(businessField: string, suffix: string): string {
        return 'business_field_color_draegerblue_' + suffix;
    }

    public resetNavigationSelection(force?: boolean): void {
        if (!force && document.body.classList.contains('nav-open')) {
            return;
        }
        this._subscriptions.push(
            this.model$.pipe(distinctUntilChanged()).subscribe((data) => {
                for (const key in data) {
                    if (data.hasOwnProperty(key)) {
                        data[key] = null;
                    }
                }
                this._$model.next(data);
            })
        );
        this._resetMobileNavStatus();
        this._setInitialNavValues();
        this._setMobileBindings();
    }

    public openMobile(displayName: string): void {
        if (!document.body.classList.contains('nav-open')) {
            document.body.classList.add('nav-open');
            // this._preselectCurrentBusinessFieldInterest(this._$navigationData.getValue());
        }
    }

    public setMobileSubMenu(value, name) {
        this._subscriptions.push(
            this.model$.pipe(distinctUntilChanged()).subscribe((data) => {
                data[name] = data[name] === value ? null : value;
                this._$model.next(data);
            })
        );
    }

    public resetChildren(parentName: string) {
        this._subscriptions.push(
            this.model$.pipe(distinctUntilChanged()).subscribe((data) => {
                data[parentName] = null;
                this._$model.next(data);
            })
        );
    }

    private _setMobileBindings() {
        const _navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));
        _navExpand.forEach((item) => {
            item.querySelector('.nav-link').addEventListener('click', () => {
                item.classList.add('active');
            });
            item.querySelector('.nav-back-link').addEventListener('click', () => {
                item.classList.remove('active');
            });
        });
    }

    private _resetMobileNavStatus() {
        const _navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));
        document.body.classList.remove('nav-open');
        _navExpand.forEach((item) => {
            item.classList.remove('active');
        });
    }

    private _setInitialNavValues() {
        this._$model.next({
            sitenavigationTopSegmentSelected0: {
                selected: false
            },
            sitenavigationTopSegmentSelected1: {
                selected: false
            },
            siteNavigationSecondLevelSelectedSegment0: '',
            siteNavigationSecondLevelSelectedSegment1: '',
            siteNavigationThirdLevelSelectedSegment0: '',
            siteNavigationThirdLevelSelectedSegment1: ''
        });
    }

    private _preselectCurrentBusinessFieldInterest(children: any[]) {
        const mainMenueItem = children;
        for (let i = 0, firstLevelNavigation; i < this.MAX_MAIN_ITEMS; i++) {
            firstLevelNavigation = mainMenueItem[i].Children;
            for (let j = 0; j <= this.MAX_BUSINESSFIELD_ITEMS; j++) {
                if (
                    firstLevelNavigation[j] &&
                    firstLevelNavigation[j].TechnicalName.toLowerCase() === this.selectedBusinessField.toLowerCase()
                ) {
                    this.model$.pipe(distinctUntilChanged()).subscribe((data) => {
                        data['siteNavigationSecondLevelSelectedSegment' + i] = 'navbartogglesegment' + i + 'level' + i + 'item' + j;
                        this._$model.next(data);
                    });
                }
            }
        }
    }
}
